import { every, isEmpty, isNull, isUndefined } from 'lodash';

/**

 * If the passed value is falsy or not
 * @param value the value of the passed parameter
 * @returns {boolean} if the value is falsy
 */
export const isFalsyValue = (value: unknown): boolean => {
  return isUndefined(value) || isNull(value) || isEmpty(value);
};

export const isAllPropertiesEmpty = <T extends object>(value: T): boolean => every(value,isFalsyValue);
